var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ul", { attrs: { id: "list-tasks" } }, [
    _c("li", [
      _c("div", { staticClass: "oblea", on: { click: _vm.selectItem } }, [
        _c("div", { attrs: { id: "imagenProductoContainer" } }, [
          _c("img", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.item.showCheck,
                expression: "item.showCheck"
              }
            ],
            attrs: { id: "check", src: "/dist/icon-check.png" }
          }),
          _vm._v(" "),
          _c("img", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.imagenProducto == null,
                expression: "imagenProducto == null"
              }
            ],
            staticStyle: { width: "40px", height: "40px" },
            attrs: { id: "imagenPlaceholder", src: "/dist/progress-item.gif" }
          }),
          _vm._v(" "),
          _c("img", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.imagenProducto != null,
                expression: "imagenProducto != null"
              }
            ],
            attrs: {
              id: "imagenProducto",
              src: _vm.imagenProducto,
              title: _vm.item.Nombre
            }
          })
        ]),
        _vm._v(" "),
        _c("p", { attrs: { id: "labelProducto" } }, [
          _vm._v(_vm._s(_vm.item.Nombre))
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-691932a1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-691932a1","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/realizarDevolucion/itemRealizarDevolucion.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-691932a1","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/realizarDevolucion/itemRealizarDevolucion.vue
// module chunks = 0